export default __webpack_public_path__ + "static/media/Cano.fa04f9bc.otf";